import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

export const constructionDailyLogDetails = createAsyncThunk('constructionDailyLogDetails', async ({ logId, navigate }) => {

    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `construction-daily-log/${logId}`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": SessionManager.getCookie("user_token"),
            },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const constructionDailyLogDetailsSlice = createSlice({
    name: 'constructionDailyLogDetails',
    initialState: {
        data: '',
    },
    reducers: {
        clearConstructionDailyLogDetails: (state) => {
            state.data = ''
        },
    },
    extraReducers: (builder) => {
        builder.addCase(constructionDailyLogDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                const responseData = action?.payload?.data
                state.data = responseData?.data ?? responseData ?? '';
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = '';
            }
        });
        builder.addCase(constructionDailyLogDetails.rejected, (state) => {
            state.data = ''
        })
    }
})

export const { clearConstructionDailyLogDetails } = constructionDailyLogDetailsSlice.actions
export default constructionDailyLogDetailsSlice.reducer;
